module.exports = __webpack_public_path__ + "img/image.f9ad77ac.png";